import { instance3 } from "App/constants"
import {
  defaultDateInputDisplay,
  oneMonthBeforeToday,
  today,
} from "App/utils/helpers"
import { startOfDay, lastOfDay } from "utils/dates"
import { getTagihanById } from "../InputTagihan/ui"

export const urlGet = "/tagihan/list"
export const urlGetExport = "/tagihan/listExport"
export const urlDelete = "/wmsfarmasi/pembelian/delete"

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  kategori_pencarian: 0,
  kata_kunci: "",
  status_pembayaran_name: "Pilih Status Pembayaran",
  status_pembayaran: "",
  nama: "",
  rm_id: "",
  eklaim_status: "",

  asuransi_id: null,
  asuransi_name: "Pilih Asuransi",

  jenis_layanan_id: null,
  jenis_layanan_name: "Pilih Jenis Layanan",

  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: today(false),
}

export const getByFilterTagihan = async (formFilter, pages, limit) => {
  try {
    const data = {
      halaman: pages,
      jumlah: limit,
      nama: formFilter.nama,
      eklaim_status: formFilter.eklaim_status,
      status_pembayaran: formFilter.status_pembayaran,
      tanggal_awal: startOfDay(formFilter.tanggal_awal),
      tanggal_akhir: lastOfDay(formFilter.tanggal_akhir),
      asuransi_id: formFilter.asuransi_id,
      jenis_layanan_id: formFilter.jenis_layanan_id,
      company_id: formFilter.company_id,
    }

    const katPencarianData = {
      0: "semua",
      1: "id_tagihan",
      2: "rm_id",
      3: "nama_rm",
      4: "id_rekap",
    }

    const katPencarian = katPencarianData[formFilter.kategori_pencarian]

    const kataKunci =
      katPencarian !== "semua"
        ? {
            [katPencarian]: formFilter.kata_kunci,
          }
        : {}

    const api = await instance3.post(urlGet, {
      ...data,
      ...kataKunci,
    })

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
        total: res.total,
        pembayaran: res.pembayaran,
        sisa: res.sisa,
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterTagihanExport = async (formFilter) => {
  try {
    const data = {
      status_pembayaran: formFilter.status_pembayaran,
      nama: formFilter.nama,
      tanggal_awal: startOfDay(formFilter.tanggal_awal),
      tanggal_akhir: lastOfDay(formFilter.tanggal_akhir),
      asuransi_id: formFilter.asuransi_id,
      jenis_layanan_id: formFilter.jenis_layanan_id,
    }

    const katPencarianData = {
      0: "semua",
      1: "id_tagihan",
      2: "rm_id",
      3: "nama_rm",
      4: "id_rekap",
    }

    const katPencarian = katPencarianData[formFilter.kategori_pencarian]

    const kataKunci =
      katPencarian !== "semua"
        ? {
            [katPencarian]: formFilter.kata_kunci,
          }
        : {}

    const api = await instance3.post(urlGetExport, {
      ...data,
      ...kataKunci,
    })

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getDataEditTagihan = async (row) => {
  const res = await getTagihanById(row.id)
  if (res.state) {
    const tagihan = res.data.tagihan
    const pembayaran = res.data.pembayaran
    const ditanggung = res.data.ditanggung

    const propsPageInputTagihan = {
      tagihan_id: row.id,
      date: defaultDateInputDisplay(row.tanggal_tagihan, true),
      type: "update",
      rm_id: row?.rm_id ?? "",
      rm_name: row?.nama ?? "",
      rm_umur: row?.rm_umur ?? "",
      rm_tanggal_lahir: row?.rm_tanggal_lahir ?? "",
      kelas_id: row?.kelas_id ?? "",
      kelas_name: row?.nama_kelas ?? "",
      asuransi_no: row?.no_asuransi ?? "",
      asuransi_id: row?.asuransi_id ?? "",
      asuransi: row?.nama_asuransi ?? "",
      jenis_layanan_id: row?.jenis_layanan_id ?? "",
      jenis_layanan_name: row?.nama_layanan ?? "",
      kunjungan_id: "",
      no_sep: row?.no_sep ?? "",
      no_npwp: row?.no_npwp ?? "",
      keterangan: row?.keterangan ?? "",
      penanggung: row?.penanggung ?? "",
      jenisrm: 2,
      status: row?.statusTagihan !== 0 ? 1 : 0,
      status_tagihan: parseInt(row?.statusTagihan),
      company_id: row.company_id ?? null,
      company_name: row.company_name ?? "",

      tagihan: {
        jumlah: tagihan.jumlah,
        potongan: tagihan.potongan,
        tax: tagihan.tax,
      },

      pembayaran: {
        total_tagihan: pembayaran.total_tagihan,
        total_pembayaran: pembayaran.total_pembayaran,
      },

      ditanggung: {
        ditanggung: ditanggung.ditanggung,
        total_tagihan: ditanggung.total_tagihan,
        jumlah_selisih: ditanggung.jumlah_selisih,
      },

      is_paket: row?.is_paket,
    }

    return {
      state: true,
      data: propsPageInputTagihan,
      message: res.message,
    }
  } else {
    return {
      state: false,
      data: {},
      message: res.message,
    }
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "IDGL",
    disablePadding: false,
    label: "IDGL",
    align: "left",
  },

  {
    id: "id_rekap_tagihan",
    disablePadding: false,
    label: "ID REKAP TAGIHAN",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "rm_id",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "no_sep",
    disablePadding: false,
    label: "NO SEP",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "rm_tanggal_lahir",
    disablePadding: false,
    label: "TGL LAHIR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_asuransi",
    disablePadding: false,
    label: "NAMA ASURANSI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "no_asuransi",
    disablePadding: false,
    label: "NO ASURANSI",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "company_name",
    disablePadding: false,
    label: "PERUSAHAAN",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "doctor_name",
    disablePadding: false,
    label: "DPJP",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "statusTagihan",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "tanggal_kunjungan",
    disablePadding: false,
    label: "TGL KUNJUNGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_PULANG",
    disablePadding: false,
    label: "TGL PULANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "selisihDitanggung",
    disablePadding: false,
    label: "SELISIH DITANGGUNG",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "selisihPaket",
    disablePadding: false,
    label: "SELISIH PAKET",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "totalTagihan",
    disablePadding: false,
    label: "TOTAL TAGIHAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "total_bayar",
    disablePadding: false,
    label: "TOTAL PEMBAYARAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "sisa",
    disablePadding: false,
    label: "SISA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "alamat",
    disablePadding: false,
    label: "ALAMAT",
    align: "left",
    minWidth: "180px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const deleteTagihanByID = async (id) => {
  try {
    const res = await instance3.post("/tagihan/delete", {
      id,
    })

    if (res.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus data",
      }
    } else {
      return {
        state: false,
        message: res.data.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const filterStatusPembayaran = [
  {
    value: 1,
    label: "Belum Lunas",
  },
  {
    value: 2,
    label: "Lunas",
  },
]
